export const IconSkype20Filled: {
  name: 'icon_skype_20_filled-410982649330'
} = {
  name: 'icon_skype_20_filled-410982649330'
}
